import { Cross, Anchor, Heart } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const PILLARS = [
  {
    icon: Cross,
    tag: "Mission",
    word: "Faith",
    title: "To carry Christ into hard places",
    body:
      "We exist to make the love of Jesus tangible — providing a safe, loving, Christ-centered home for vulnerable children, strengthening missionaries in difficult circumstances, and sharing the Gospel inside real relationships.",
    tone: "navy",
  },
  {
    icon: Anchor,
    tag: "Vision",
    word: "Hope",
    title: "Children secure, families self-sufficient",
    body:
      "We long to see children who once had nowhere to sleep grow into adults who know they are loved, and families in Honduras equipped to stand on their own with dignity and hope that holds.",
    tone: "crimson",
  },
  {
    icon: Heart,
    tag: "Values",
    word: "Love",
    title: "Faithful, present, and unhurried",
    body:
      "Christ at the center. Presence over programs. Dignity always. Compassion that costs something. And a stubborn commitment to raising up others rather than doing everything ourselves.",
    tone: "sage",
  },
];

const TONES = {
  navy: "bg-navy text-sand",
  crimson: "bg-crimson text-sand",
  sage: "bg-sage text-sand",
};

export const MissionVision = () => (
  <section id="mission" data-testid="mission-vision-section" className="bg-sand-dim py-28 lg:py-36">
    <div className="mx-auto max-w-[1500px] px-6 lg:px-12">
      <Reveal className="max-w-4xl">
        <Eyebrow>Our Mission</Eyebrow>
        <p className="font-display mt-8 text-[1.5rem] leading-[1.32] tracking-[-0.01em] text-navy sm:text-[2rem] lg:text-[2.4rem]">
          Three Abide Ministries exists to serve vulnerable children and families in Honduras through{" "}
          <span className="italic text-crimson">Christ-centered</span> relationships, practical
          assistance, and opportunities for families to become more self-sufficient.
        </p>
        <p className="mt-8 max-w-2xl text-base leading-[1.8] text-navy/70">
          We seek to live out our faith as a family by caring for those in need, developing lasting
          relationships, and demonstrating the love of Christ through practical service.
        </p>
      </Reveal>

      <div className="mt-16 grid gap-5 md:grid-cols-3">
        {PILLARS.map((p, i) => {
          const Icon = p.icon;
          return (
            <Reveal key={p.tag} delay={0.1 + i * 0.1}>
              <article
                data-testid={`pillar-card-${p.tag.toLowerCase()}`}
                className={`group relative flex h-full flex-col justify-between overflow-hidden p-8 transition-transform duration-500 hover:-translate-y-2 lg:p-10 ${TONES[p.tone]}`}
              >
                <div
                  className="pointer-events-none absolute -right-10 -top-10 h-44 w-44 rounded-full bg-white/10 blur-2xl"
                  style={{ opacity: 0.4 }}
                />
                <div className="relative">
                  <Icon size={22} className="text-sand/70" />
                  <p className="font-display mt-10 text-5xl italic leading-none text-sand/95">
                    {p.word}
                  </p>
                </div>
                <div className="relative mt-14">
                  <h3 className="font-display text-xl leading-snug text-sand">{p.title}</h3>
                  <p className="mt-4 text-sm leading-relaxed text-sand/75">{p.body}</p>
                </div>
              </article>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
